import { IAvatar, IMessage } from "@/shared/types";
import { IPaginationParams, IPaginationResponse } from "@/shared/types/app";

export enum AiChatsSortType {
  NEWEST = "newest",
  POPULAR = "popular",
}

export interface IAiChat {
  id: string;
  title: string;
  description: string;
  avatar: IAvatar;
  has_dialog: boolean;
}

export interface IMyAiChat {
  id: string;
  title: string;
  description: string;
  avatar: IAvatar;
  last_message: IMessage;
}

export interface IGetAllChatsParams extends IPaginationParams {
  sort?: AiChatsSortType;
}

export interface IGetAllChatsResponse {
  data: IAiChat[];
  pagination: IPaginationResponse;
}

export interface IGetMyChatsParams extends IPaginationParams {}

export interface IGetMyChatsResponse {
  data: IMyAiChat[];
  pagination: IPaginationResponse;
}
